import { render, staticRenderFns } from "./TableCommCode.vue?vue&type=template&id=1a42add6&"
import script from "./TableCommCode.vue?vue&type=script&lang=js&"
export * from "./TableCommCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports